import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M6.569 15.314 4.896 13.64a2.5 2.5 0 0 1-.002-3.534l4.473-4.482 5.208 5.208-4.469 4.479a2.5 2.5 0 0 1-3.537.002ZM16.242 15a1.042 1.042 0 1 1-2.084 0c0-.575.467-1.875 1.042-1.875s1.042 1.3 1.042 1.875Zm-6.25-4.792v-6.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);